import React from 'react';
import styled from 'styled-components';

/**
 * Props for the Sidebar component.
 */
interface SidebarProps {
  children: React.ReactNode;
  collapsed?: boolean;
}

/**
 * Sidebar component for the dashboard.
 * Contains various information panels and controls.
 */
const Sidebar: React.FC<SidebarProps> = ({ children, collapsed = false }) => {
  return (
    <SidebarContainer $collapsed={collapsed}>
      {children}
    </SidebarContainer>
  );
};

interface CollapsibleProps {
  $collapsed: boolean;
}

/**
 * Styled container for the sidebar.
 */
const SidebarContainer = styled.aside<CollapsibleProps>`
  width: ${props => props.$collapsed ? '0' : '300px'};
  min-width: ${props => props.$collapsed ? '0' : '300px'};
  max-width: ${props => props.$collapsed ? '0' : '300px'};
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  border-right: 1px solid ${({ theme }) => theme.colors.border};
  transition: all 0.3s ease;
  overflow: hidden;
  flex-shrink: 0;
  flex-grow: 0;
  position: relative;
  display: flex; /* Ensure the inner content fills the sidebar */
  flex-direction: column; /* Stack children vertically */
  min-height: 0; /* Critical for flex layout nesting */
  
  /* Mobile styles */
  @media (max-width: 768px) {
    width: 300px; /* Fixed width on mobile, even when collapsed */
    min-width: 300px;
    max-width: 300px;
    /* Actual visibility is controlled by transform in the parent */
  }
`;

export default Sidebar; 